<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block">
          <div class="d-flex">
            <span class="search-wrapper">
              <SearchInput :searchChange="searchChange" />
            </span>
            <div class="status-buttons-block">
              <div
                v-for="btn in statusButtons"
                :key="btn.value"
                @click="statusChange(btn.value)"
                :class="`status-button ${filter.status === btn.value ? 'status-button-active' : ''}`"
              >
                <div v-if="btn.color" :class="`dot ${btn.color}-status`"></div>
                {{ btn.name | i18n }}
              </div>
            </div>
          </div>
          <div class="d-flex">
            <b-button variant="primary" size="lg" class="pl-3 pr-4 d-flex align-items-center" @click="goToNewTicketPage">
              <BIconPlus class="mr-2" />
              {{ 'New Ticket' | i18n }}
            </b-button>
            <b-button
              v-if="CAN_DELETE.includes(auth.role)"
              variant="outline-danger"
              size="lg"
              class="ml-3 pl-4 pr-4 d-flex align-items-center"
              :disabled="!selectedList.length"
              @click="deleteTickets"
            >
              <img :src="deleteIconUrl" class="mr-2" />
              {{ 'Remove Tickets' | i18n }}
            </b-button>
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="columns"
          :rows="rows"
          :filter="filter"
          :updateFilter="updateFilter"
          :loadingInstance="loadingInstance"
          :setLoadingInstance="setLoadingInstance"
          :selectedList="selectedList"
          :setSelectedList="setSelectedList"
          class="overflow-auto pr-1"
          tableName="casesTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { BIconArrowRightShort, BIconPlus, BIconSearch } from 'bootstrap-vue';
import DateRangePicker from 'vue2-daterange-picker';

import api from '../../../api';
import { ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin } from '../../../../mixins';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import { TICKET_STATUSES, CAN_DELETE } from '../../../../../../../constants';
import DeleteIcon from '../../../../assets/icons/delete.svg';
import DetailsIcon from '../../../../assets/icons/iconsCode/details.vue';

let inputInterval = null;

export default {
  title: 'Tickets',
  components: { BIconPlus, BIconSearch, Table, SearchInput, DateRangePicker, DetailsIcon },
  mixins: [ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin],
  data() {
    return {
      deleteIconUrl: DeleteIcon,
      selectedList: [],
      loadingInstance: null,
      CAN_DELETE: CAN_DELETE,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        status: '',
        dateRange: {},
        searchQuery: '',
      },
      statusButtons: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'New',
          value: TICKET_STATUSES.NEW,
          color: 'new',
        },
        {
          name: 'In Progress',
          value: TICKET_STATUSES.IN_PROGRESS,
          color: 'inprogress',
        },
        {
          name: 'Finished',
          value: TICKET_STATUSES.FINISHED,
          color: 'finished',
        },
      ],
      columns: [
        {
          field: 'status',
          key: 'status',
          title: '',
          width: 0,
          renderBodyCell: ({ row, column }) => {
            const cellData = row[column.field];
            const color = (() => {
              switch (cellData) {
                case TICKET_STATUSES.NEW:
                  return 'new';
                case TICKET_STATUSES.IN_PROGRESS:
                  return 'inprogress';
                case TICKET_STATUSES.FINISHED:
                  return 'finished';
              }
            })();
            return <div class={`status-cell ${color}-status`} />;
          },
        },
        {
          field: 'template.name',
          title: this.$translate('template'),
          key: 'template.name',
          align: 'left',
          sortBy: '',
          renderBodyCell: ({ row }, h) => row.templateTitle,
        },
        {
          field: 'title',
          title: this.$translate('Title'),
          key: 'title',
          align: 'left',
        },
        {
          field: 'teamName',
          title: this.$translate('team'),
          key: 'teamName',
          align: 'left',
        },
        {
          field: 'userName',
          title: this.$translate('Assigned User'),
          key: 'userName6',
          width: 200,
        },
        {
          field: 'createdAt',
          title: this.$translate('Date Created'),
          key: 'createdAt',
          sortBy: 'desc',
          width: 200,
        },
        {
          field: 'actions',
          key: 'actions',
          title: '',
          width: 50,
          renderBodyCell: ({ row }) => {
            return (
              <b-button variant="primary" size="sm" class="p-2 size-12" on-click={() => this.goToTicket(row.id)}>
                <DetailsIcon />
              </b-button>
            );
          },
        },
      ],
      rows: [],
    };
  },
  created() {
    if (this.CAN_DELETE.includes(this.auth.role)) {
      const columns = [...this.columns];
      columns.splice(1, 0, {
        field: 'check',
        key: 'check',
        type: 'checkbox',
        title: '',
        width: 50,
        align: 'center',
      });
      this.columns = columns;
    }
  },
  methods: {
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    dateRangeChange(date) {
      this.filter.dateRange = {
        endDate: date.endDate ? moment(date.endDate).format('YYYY-MM-DD') : '',
        startDate: date.startDate ? moment(date.startDate).format('YYYY-MM-DD') : '',
      };
      this.getPage();
    },
    statusChange(status) {
      this.filter.status = status;
      this.getPage();
    },
    goToNewTicketPage() {
      this.$router.push({ name: 'new-ticket' });
    },
    goToTicket(id) {
      this.$router.push({ name: 'ticket-details', params: { id } });
    },
    async deleteTickets() {
      try {
        await this.deleteSelectedRows(
          {
            message: this.$translate('case_delete_message'),
            rowDisplayValues: this.selectedList.map((r) => r.caseNumberString),
          },
          async () => {
            const ids = this.selectedList.map((r) => r.id);
            await api.ticket.delete({ ids });
            this.rows = this.rows.filter((i) => !ids.includes(i.id));
            this.selectedList = [];
            this.getPage();
          }
        );
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, status, dateRange, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (status) {
          ctx.status = status;
        }
        if (dateRange && dateRange.startDate && dateRange.endDate) {
          ctx.startDate = dateRange.startDate;
          ctx.endDate = dateRange.endDate;
        }
        const response = await api.ticket.get(ctx);
        response.data = response.data.map((item) => ({
          ...item,
          teamName: item.team ? item.team.name : '',
          createdAt: moment(item.createdAt).format('DD.MM.YY HH:mm'),
          templateTitle: item.template ? item.template.name : '',
          userName: item.user ? item.user.name : '',
        }));
        this.filter.totalCount = response.totalCount;
        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      } finally {
        this.stopLoading();
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: auto;
}

::v-deep .status-cell {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  border-radius: 0 2px 2px 0;
}
::v-deep .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
::v-deep .new-status {
  background-color: rgb(37, 154, 43);
}
::v-deep .inprogress-status {
  background-color: rgb(239, 255, 15);
}
::v-deep .finished-status {
  background-color: rgb(90, 98, 107);
}

.status-button {
  border: 1px solid #c5d0de;
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  line-height: 16px;
  color: rgba(100, 106, 135, 0.6);
  display: flex;
  align-items: center;
  &:first-child {
    border-radius: 4px 0px 0px 4px;
  }
  &:last-child {
    border-radius: 0px 4px 4px 0px;
  }
}

.status-button-active {
  color: #2260ff;
  background: rgba(34, 96, 255, 0.1);
  border: 1px solid #2260ff;
}

.search-wrapper {
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.status-buttons-block {
  display: flex;
  flex-wrap: wrap;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.status-block {
  display: flex;
  margin-left: 20px;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.status-name {
  margin-left: 10px;
  font-size: 14px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .size-12 {
  font-size: 12px;
  line-height: 12px;
}
</style>
